export const POSTFIX = '\u20bd';
export const MAP_TO_RADIX = [',', '.', 'Б', 'Ю'];
export const MAX_PRICE = 999_999_999_999;
export const MIN_PRICE = 0;
export const PRICE_SEPARATOR = ' ';
